import { useCallback } from 'react';

import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';
import { DownloadIcon } from '../icons/Download';

export const DownloadAudio = () => {
  const handleDownload = useCallback(async () => {
    redirectToOnboardingCheckout();
    return;
  }, []);

  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        logEvent('download_interaction', {
          action: 'clicked',
        });
        handleDownload();
      }}
      className={`flex h-12 cursor-pointer items-center justify-center gap-2 rounded-[16px] border-[1px] border-[#E9EAF0] px-4 py-3 hover:bg-[#E9EAF0]`}>
      <DownloadIcon />
      <div className="hidden @sm:block">Download</div>
    </button>
  );
};
